import React, { useState, useEffect } from 'react';
import {
  Box,
  useMediaQuery,
  useTheme,
  Typography,
} from '@mui/material';

import { Outlet, useLocation } from 'react-router-dom';

import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import GlobalLoader from '../Loader/GlobalLoader';

const MainLayout = () => {
  const theme = useTheme();
  const location = useLocation();

  const isMobile = useMediaQuery(
    theme.breakpoints.down('md')
  );

  const [isSidebarOpen, setIsSidebarOpen] =
    useState(!isMobile);

  const [isLoading, setIsLoading] = useState(false);

  // Sidebar Width
 const sidebarWidth = isMobile ? '65px' : '65px';

  useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    // Mobile route change ला sidebar close
    if (isMobile) {
      setIsSidebarOpen(false);
    }

    return () => clearTimeout(timer);
  }, [location.pathname, isMobile]);

  // Screen resize fix
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [isMobile]);

  const handleToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        bgcolor: '#f4f7fa',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      {/* Loader */}
      <GlobalLoader open={isLoading} />

      {/* SIDEBAR */}

      <Box
        sx={{
          width: sidebarWidth,
          height: '100vh',

          position: isMobile ? 'fixed' : 'relative',

          top: 0,
          left: 0,

          zIndex: 1400,

          bgcolor: '#ffffff',

          borderRight: '1px solid #E2E8F0',

          overflow: 'visible',

          flexShrink: 0,

          transition: 'transform 0.3s ease',

          // MOBILE SLIDE
          transform: isMobile
            ? isSidebarOpen
              ? 'translateX(0)'
              : 'translateX(-100%)'
            : 'translateX(0)',
        }}
      >
        <Sidebar />
      </Box>

      {/* RIGHT SECTION */}

      <Box
        sx={{
          flexGrow: 1,

          display: 'flex',
          flexDirection: 'column',

          height: '100vh',

          width: '100%',

          overflow: 'hidden',
        }}
      >
        {/* TOPBAR */}

        <Topbar toggleSidebar={handleToggle} />

        {/* MAIN CONTENT */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,

            overflowY: 'auto',
            overflowX: 'hidden',

            bgcolor: '#f4f7fa',

            p: {
              xs: 1,
              md: 2,
            },

            height: 'calc(100vh - 65px - 35px)',

            width: '100%',
          }}
        >
          <Outlet />
        </Box>

        {/* FOOTER */}

        <Box
          component="footer"
          sx={{
            height: '35px',

            bgcolor: '#ffffff',

            borderTop: '1px solid #E2E8F0',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            flexShrink: 0,

            width: '100%',

            zIndex: 1200,

            boxShadow:
              '0px -2px 5px rgba(0,0,0,0.03)',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '1rem',
              color: '#1a237e',
              textAlign: 'center',
              px: 1,
            }}
          >
            <span style={{ color: '#E91E63' }}>
              COM
            </span>

            <span style={{ color: '#03A9F4' }}>
              TRANSE
            </span>

            <span
              style={{
                color: '#1E293B',
                marginLeft: '4px',
              }}
            >
              TECHNOLOGY PVT.LTD.KOLHAPUR
            </span>
          </Typography>
        </Box>
      </Box>

      {/* MOBILE OVERLAY */}

      {isMobile && isSidebarOpen && (
        <Box
          onClick={handleToggle}
          sx={{
            position: 'fixed',
            inset: 0,

            bgcolor: 'rgba(0,0,0,0.35)',

            zIndex: 1300,
          }}
        />
      )}
    </Box>
  );
};

export default MainLayout;